import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiagram = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "nonzero",
		d: "M14.945 14.08h8.068a1 1 0 0 1 1 1v5.142H27a1 1 0 0 1 1 1V27a1 1 0 0 1-1 1h-7.704a1 1 0 0 1-1-1v-5.778a1 1 0 0 1 1-1h2.717V16.08H5.969v4.143h2.735a1 1 0 0 1 1 1V27a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-5.778a1 1 0 0 1 1-1h2.97V15.08a1 1 0 0 1 1-1h7.975v-3.308a1.924 1.924 0 0 1-.376-2.993h-2.476a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7.704a1 1 0 0 1 1 1v5.778a1 1 0 0 1-1 1h-2.478a1.924 1.924 0 0 1-.374 2.992zm1.852-8.302V2h-5.704v3.778zM7.704 26v-3.778H2V26zM26 26v-3.778h-5.704V26z"
	})
});
export default SvgDiagram;
